import { cn } from "@/utils/styles";
import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { TextInputProps } from "./TextInput";

const PasswordInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      onChange,
      value = "",
      name,
      placeholder,
      className = "",
      disabled,
      error,
      onFocus,
      onBlur,
      onKeyDown,
      onPaste,
      disabledOnWheel = false,
      min,
      step,
      max
    },
    ref
  ) => {
    const [showValue, setShowValue] = useState(false);

    const toggleVisibility = () => {
      setShowValue(!showValue);
    };

    return (
      <div className={cn("relative flex w-full items-center", className)}>
        <input
          ref={ref}
          spellCheck={false}
          disabled={disabled}
          style={{ boxShadow: "none" }}
          type={showValue ? "text" : "password"}
          value={value}
          name={name}
          onChange={(e) => onChange(e.target.value)}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          onPaste={onPaste}
          placeholder={placeholder}
          className={cn(
            "subtext-small h-[40px] flex-1 rounded-[8px] border border-gray-dark-200 bg-background py-[10px] pl-3 pr-10 text-foreground transition-colors placeholder:text-muted-foreground",
            error ? "border-red-dark-300" : ""
          )}
          onWheel={disabledOnWheel ? (e) => (e.target as HTMLInputElement).blur() : undefined}
          min={min}
          step={step}
          max={max}
        />
        <button
          type="button"
          onClick={toggleVisibility}
          className="absolute right-3 text-muted-foreground hover:text-foreground focus:outline-none"
          tabIndex={-1}
        >
          {showValue ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      </div>
    );
  }
);

PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
